import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param orgId
 * @param templateRouteId
 * @param poId
 */
class TemplateRouteServices {
  /**
   *
   * @param {*} payload
   * @return
   */
  createTemplateRoute = async (payload) => {
    const templateRoute = await Helpers.post({
      url: Constants.TEMPLATE_ROUTE,
      data: payload,
    });
    return templateRoute;
  };

  /**
   *
   * @param {*} payload
   * @return
   */
  updateTemplateRoute = async (payload) => {
    const templateRoute = await Helpers.put({
      url: Constants.TEMPLATE_ROUTE,
      data: payload,
    });
    return templateRoute;
  };

  /**
  *
  * @param {*} payload
  * @return
  */
  updateAssignee = async (payload) => {
    const assignee = await Helpers.put({
      url: Constants.UPDATE_ASSIGNEE,
      data: payload,
    });
    return assignee;
  };

  updateTemplateRouteStatus = async (payload) => {
    const po = await Helpers.put({
      url: Constants.TEMPLATE_ROUTE_STATUS,
      data: payload,
    });
    return po;
  };

  updateTemplateRouteStatusV2 = async (payload) => {
    const po = await Helpers.put({
      url: Constants.JOB_WORK_STATUS_V2,
      data: payload,
    });
    return po;
  };

  /**
   *
   * @param {*} payload
   * @return
   */
  updateTemplateRouteWorkflowStep = async (payload) => {
    const templateRoute = await Helpers.post({
      url: Constants.TEMPLATE_ROUTE_WORKFLOW,
      data: payload,
    });
    return templateRoute;
  };

  /**
   * @param templateRouteId
   * @param {*} payload
   * @return
   */
  deleteTemplateRoute = async (payload) => {
    const templateRoute = await Helpers.delete({
      url: Constants.TEMPLATE_ROUTE,
      data: payload,
    });
    return templateRoute;
  };

  /**
   * @param {*} orgId
   * @return
   */
  getTemplateRoutes = async (orgId, page, limit, searchKeyword, tenants) => {
    let url = `${Constants.TEMPLATE_ROUTE}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (tenants) url += `tenant_ids=${tenants}&`;

    const TemplateRoutes = await Helpers.get({ url });

    return TemplateRoutes;
  };

  /**
     * @param {*} orgId
     * @return
     */
  getTemplateRouteById = async (orgId, templateRouteId) => {
    let url = `${Constants.TEMPLATE_ROUTE}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (templateRouteId) url += `template_production_route_id=${templateRouteId}&`;

    const TemplateRoutes = await Helpers.get({ url });

    return TemplateRoutes;
  };
}
export default new TemplateRouteServices();
